import { clsx } from "clsx";

import stackedDark from "../assets/brand/qwiksupport-logo-dark.png";
import horizontalDark from "../assets/brand/qwiksupport-logo-horizontal-dark.png";
import horizontalLight from "../assets/brand/qwiksupport-logo-horizontal-light.png";
import stackedLight from "../assets/brand/qwiksupport-logo-light.png";
import styles from "./Logo.module.css";

// The supplied logo (the headset over the name) and its horizontal arrangement, made from the
// same pixels: the headset, with its microphone moved up to the ear cup, beside the name and the
// tagline.
const IMAGES = {
  stacked: { dark: stackedDark, light: stackedLight, width: 1146, height: 682 },
  horizontal: { dark: horizontalDark, light: horizontalLight, width: 1591, height: 258 },
};

/** The QwikSupport logo image in its version for the theme: the supplied navy logo with
 * "Support" in indigo on the light theme; white with a lighter indigo on the dark one. CSS shows
 * one of the two, and a lazy image loads only once it is shown. */
export function Logo({
  layout = "stacked",
  alt = "QwikSupport",
  className,
}: {
  layout?: keyof typeof IMAGES;
  alt?: string;
  className?: string;
}) {
  const { dark, light, width, height } = IMAGES[layout];
  return (
    <>
      <img
        src={dark}
        alt={alt}
        width={width}
        height={height}
        loading="lazy"
        className={clsx(styles.logo, styles.dark, className)}
      />
      <img
        src={light}
        alt={alt}
        width={width}
        height={height}
        loading="lazy"
        className={clsx(styles.logo, styles.light, className)}
      />
    </>
  );
}
